"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.DatePickerInput = void 0;

var _react = _interopRequireWildcard(require("react"));

var _moment = _interopRequireDefault(require("moment"));

require("moment-timezone");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactDatepicker = _interopRequireDefault(require("react-datepicker"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _reactDeviceDetect = require("react-device-detect");

require("react-datepicker/dist/react-datepicker.css");

var _Icon = _interopRequireDefault(require("../../icons/Icon"));

var _lodash = _interopRequireDefault(require("lodash"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var DATE_FORMAT_STR = "MM/DD/YYYY";
var DATE_FORMAT_STR_WITH_TIME = "MM/DD/YYYY hh:mm a";

var DatePickerInputGroup = _styledComponents["default"].div.attrs(function () {
  return {
    className: "input-group"
  };
}).withConfig({
  displayName: "DatePickerInput__DatePickerInputGroup",
  componentId: "sc-1wau1ml-0"
})(["&&&{> div:nth-child(2){position:relative;flex:1 1 auto;}.react-datepicker__input-container{display:block;}.react-datepicker-wrapper{width:calc(100% - 30px);display:block;}.react-datepicker__day--outside-month{color:", ";}.react-datepicker-popper{z-index:1100;}}"], function (props) {
  return props.theme["grey"];
});

var StyledInput = _styledComponents["default"].input.attrs(function () {
  return {
    className: "form-control",
    name: "best-input"
  };
}).withConfig({
  displayName: "DatePickerInput__StyledInput",
  componentId: "sc-1wau1ml-1"
})(["&&&{::placeholder{color:", ";opacity:1;font-style:italic;}:focus{background-color:", ";}", ";", ";border-top-left-radius:0.25rem;border-bottom-left-radius:0.25rem;border-top-right-radius:0;border-bottom-right-radius:0;border-right:none;&:disabled{font-style:oblique;}}"], function (props) {
  return props.theme["grey"];
}, function (props) {
  return props.theme["focus-color"];
}, function (props) {
  return props.disabled ? "background-color: " + props.theme["light-grey"] + ";" : "";
}, function (props) {
  return props.disabled ? "color: " + props.theme["grey"] + ";" : "";
});

var InputGroup = _styledComponents["default"].div.attrs(function () {
  return {
    className: "input-group-append"
  };
}).withConfig({
  displayName: "DatePickerInput__InputGroup",
  componentId: "sc-1wau1ml-2"
})(["&&&{width:30px;}"]);

var InputGroupText = _styledComponents["default"].div.attrs(function () {
  return {
    className: "input-group-text"
  };
}).withConfig({
  displayName: "DatePickerInput__InputGroupText",
  componentId: "sc-1wau1ml-3"
})(["&&&{background-color:", ";padding-left:0px;padding-right:10px;padding-bottom:0px;padding-top:0px;border-left:none;width:30px;", "}"], function (props) {
  return props.disabled ? props.theme["light-grey"] : props.theme["white"];
}, function (props) {
  return props.isInvalid ? "border-right: 1px solid #dc3545; border-top: 1px solid #dc3545; border-bottom: 1px solid #dc3545;" : "";
});

var StyledDatePicker = _styledComponents["default"].input.attrs(function () {
  return {
    className: "form-control"
  };
}).withConfig({
  displayName: "DatePickerInput__StyledDatePicker",
  componentId: "sc-1wau1ml-4"
})(["&&&{min-width:100px;::-webkit-clear-button{display:none;-webkit-appearance:none;}}"]);
/**
 * Date picker with BCR Styling
 */


var DatePickerInput = function DatePickerInput(_ref) {
  var value = _ref.value,
      _onChange = _ref.onChange,
      className = _ref.className,
      disabled = _ref.disabled,
      minDate = _ref.minDate,
      maxDate = _ref.maxDate,
      portal = _ref.portal,
      showTimeSelect = _ref.showTimeSelect,
      timeZone = _ref.timeZone,
      styles = _ref.styles,
      rest = _objectWithoutProperties(_ref, ["value", "onChange", "className", "disabled", "minDate", "maxDate", "portal", "showTimeSelect", "timeZone", "styles"]);

  var datePicker = (0, _react.useRef)(null);
  var mobileDatePicker = (0, _react.useRef)(null);

  var iconClicked = function iconClicked(event) {
    event.preventDefault();
    datePicker.current.setOpen(true);
  };

  var openMobileDatePicker = function openMobileDatePicker(event) {
    event.preventDefault();
    mobileDatePicker.current.focus();
  };

  var formatForHTML5 = function formatForHTML5(value, showTimeSelect) {
    return value ? showTimeSelect ? (0, _moment["default"])(value.toDate()).format(_moment["default"].HTML5_FMT.DATETIME_LOCAL) : (0, _moment["default"])(value.toDate()).format(_moment["default"].HTML5_FMT.DATE) : "";
  };

  var updateFromHTML5 = _lodash["default"].debounce(function (value, onChange) {
    if (value) {
      onChange(value);
    }
  }, 1000);

  var dateFormat = showTimeSelect ? DATE_FORMAT_STR_WITH_TIME : DATE_FORMAT_STR;
  var dateWithTz = value ? (0, _moment["default"])(value).tz(timeZone) : null;
  var mobileType = showTimeSelect ? "datetime-local" : "date";
  var isInvalid = className && className.includes("is-invalid");
  return _react["default"].createElement("div", {
    id: "best-datepicker"
  }, _react["default"].createElement(_reactDeviceDetect.BrowserView, null, _react["default"].createElement(DatePickerInputGroup, null, _react["default"].createElement(_reactDatepicker["default"], _extends({
    selected: dateWithTz,
    onChange: _onChange,
    showTimeSelect: showTimeSelect,
    dateFormat: dateFormat,
    disabled: disabled,
    className: className,
    peekNextMonth: true,
    showMonthDropdown: true,
    showYearDropdown: true,
    dropdownMode: "select",
    minDate: minDate,
    maxDate: maxDate,
    ref: datePicker,
    customInput: _react["default"].createElement(StyledInput, {
      value: value,
      showTimeSelect: showTimeSelect
    }),
    popperContainer: portal
  }, rest)), _react["default"].createElement(InputGroup, {
    onClick: iconClicked
  }, _react["default"].createElement(InputGroupText, {
    disabled: disabled,
    isInvalid: isInvalid
  }, _react["default"].createElement(_Icon["default"], {
    iconName: "fa-calendar-alt",
    styles: styles.icon
  }))))), _react["default"].createElement(_reactDeviceDetect.MobileView, null, _react["default"].createElement(StyledDatePicker, {
    type: mobileType,
    ref: mobileDatePicker,
    onChange: function onChange(event) {
      updateFromHTML5(event.target.value, _onChange);
    },
    disabled: disabled,
    value: formatForHTML5(dateWithTz, showTimeSelect)
  })));
};

exports.DatePickerInput = DatePickerInput;
DatePickerInput.propTypes = {
  /** class names to add to the date picker */
  className: _propTypes["default"].string,

  /** if the date picker is disabled */
  disabled: _propTypes["default"].bool,

  /** What the default date should be */
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]).isRequired,

  /** on change callback */
  onChange: _propTypes["default"].func.isRequired,

  /** if time select should show */
  showTimeSelect: _propTypes["default"].bool,

  /** timezone of the date */
  timeZone: _propTypes["default"].string,

  /** name of the date picker */
  name: _propTypes["default"].string,

  /** portal to override */
  portal: _propTypes["default"].func,

  /** customized styled onject */
  styles: _propTypes["default"].shape({
    icon: _propTypes["default"].shape({
      hoverColor: _propTypes["default"].string,
      size: _propTypes["default"].string,
      color: _propTypes["default"].string
    }),
    datepicker: _propTypes["default"].object
  }),

  /** min date allowed to selected */
  minDate: _propTypes["default"].object,

  /** max date allowed to selected */
  maxDate: _propTypes["default"].object
};
DatePickerInput.defaultProps = {
  className: "",
  name: "best-date-picker",
  disabled: false,
  showTimeSelect: false,
  minDate: (0, _moment["default"])(new Date("1/1/2011").valueOf()),
  maxDate: (0, _moment["default"])(new Date("1/1/2050").valueOf()),
  timeZone: _moment["default"].tz !== undefined ? _moment["default"].tz.guess() : "America/New_York",
  portal: null,
  styles: {
    icon: {},
    datepicker: {}
  }
};
var _default = DatePickerInput;
exports["default"] = _default;